import React from 'react';
import { SAMSNaturalMortalityGBSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'scallop-natural-mortality-gb';

interface ScallopNaturalMortalityGBData {
  samsNaturalMortalityGB?: number;
  dbSamsNaturalMortalityGB?: number;
  updatingParams?: boolean;
}

export default function ScallopNaturalMortalityGB(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<ScallopNaturalMortalityGBData>(props);

  const dbSamsNaturalMortalityGB = data.dbSamsNaturalMortalityGB ?? 0.2;
  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const samsNaturalMortalityGB =
    formValue ?? data.samsNaturalMortalityGB ?? dbSamsNaturalMortalityGB ?? 0.2;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = parseFloat(e.target.value);
      formContext?.setValue(SLUG, newValue);
    },
    [formContext]
  );

  return (
    <SAMSNaturalMortalityGBSlider
      samsNaturalMortalityGB={samsNaturalMortalityGB}
      dbSamsNaturalMortalityGB={dbSamsNaturalMortalityGB}
      handleNaturalMortalityGBChange={handleChange}
      updatingParams={data.updatingParams ?? false}
    />
  );
}
